"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Details = exports.Column = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("../typography");

var _EmployerLogo = require("../EmployerLogo");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Body = _styledComponents.default.div.withConfig({
  displayName: "Body",
  componentId: "vef7f4-0"
})(["margin:0.25rem 0 0;"]);

var Column = _styledComponents.default.div.withConfig({
  displayName: "Column",
  componentId: "vef7f4-1"
})(["display:flex;flex:0 1 auto;flex-direction:column;align-items:flex-start;justify-content:center;", "{margin-bottom:0.25rem;}& > ", "{margin:0;}"], _typography.H2, _typography.P);

exports.Column = Column;

var Details = _styledComponents.default.div.withConfig({
  displayName: "Details",
  componentId: "vef7f4-2"
})(["display:flex;align-items:flex-start;", ":not(:first-child){margin-left:24px;}"], Column);

exports.Details = Details;

var JobDetailsWidget = function JobDetailsWidget(_ref) {
  var children = _ref.children,
      listing = _ref.listing,
      logoURL = _ref.logoURL;
  return _react.default.createElement(Details, null, logoURL && _react.default.createElement(Column, null, _react.default.createElement(_EmployerLogo.EmployerLogo, {
    src: logoURL
  })), _react.default.createElement(Column, null, _react.default.createElement(_typography.H2, null, listing.title), _react.default.createElement(_typography.P, null, listing.company), _react.default.createElement(Body, null, children)));
};

var _default = JobDetailsWidget;
exports.default = _default;